import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListPage from "./pages/AccettazioneSsnListaPage.vue";
import AccettazioneRicettaPrestazioniListaPage from "../ricettaprestazioniappuntamenti/pages/AccettazioneRicettaPrestazioniListaPage.vue"
import AccettazionePrestazioniListPage from "../appuntamenti/pages/AccettazionePrestazioniListPage.vue"
export default {
    AccettazioneSsnListPage,
    AccettazioneSsnEditViewPage,
    AccettazioneRicettaPrestazioniListaPage,
    AccettazionePrestazioniListPage
};
